import { FC, ImgHTMLAttributes } from "react";
import useImage from "utils/hooks/useImage";
import styled, { css } from "styled-components/macro";

export interface IResponsiveImage extends ImgHTMLAttributes<HTMLImageElement> {
  mobileSize?: string;
  tabletSize?: string;
  desktopSize?: string;

  aspectRatio?: string;
  width?: string;
  borderRadius?: string;
  minWidth?: string;

  imgSrc?: string;
  sizes?: string;
  alt?: string;
  loadingType?: "lazy" | "eager";
}

export const ResponsiveImage: FC<IResponsiveImage> = ({
  // Approximately how large is the image on these display sizes.
  mobileSize = "90vw",
  tabletSize = "90vw",
  desktopSize = "90vw",

  aspectRatio = undefined,
  width = "100%",
  borderRadius = "8px",
  minWidth = undefined,

  imgSrc = undefined,
  sizes = undefined,
  alt = "",
  loadingType,
  ...props
}) => {
  const { imageData } = useImage(imgSrc);

  const Img = styled.img`
    object-fit: cover;
    ${aspectRatio &&
    css`
      aspect-ratio: ${aspectRatio};
    `};
    ${minWidth &&
    css`
      min-width: ${minWidth};
    `};
    width: ${width};
    border-radius: ${borderRadius};
  `;

  return (
    <Img
      src={imageData?.s.src ? imageData?.s.src : ""}
      srcSet={`
                ${imageData?.s.src} 300w,
                ${imageData?.m.src} 1000w,
                ${imageData?.l.src} 1500w`}
      alt={alt}
      sizes={`(max-width: 570px) ${mobileSize}, (max-width: 768px) ${tabletSize}, (min-width: 1280px) ${desktopSize}, 300px`}
      loading={loadingType}
      {...props}
    />
  );
};
